<header class="navigation-header">
  <div class="nav-container">
    <!-- Logo -->
    <div class="logo">
      <div class="logo-icon">
        <img src="/scryber-logo-lime.png?v=4" alt="Scryber" class="logo-image" />
      </div>
    </div>

    <!-- Navigation Links -->
    <nav class="nav-links">
      @for (link of navLinks; track link.name) {
        <a
          class="nav-link"
          [class.nav-link--icon-only]="link.icon === 'home'"
          [class.active]="link.active"
          [routerLink]="link.route"
          routerLinkActive="active"
          [attr.aria-label]="link.icon === 'home' ? link.name : null">
          @if (link.icon === 'home') {
            <svg
              class="nav-home-icon"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5z" />
            </svg>
          } @else {
            {{ link.name }}
          }
        </a>
      }
    </nav>

    <!-- Right Actions -->
    <div class="right-actions">
      <button class="action-button" (click)="onNewRecording()">
        <svg class="mic-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
          <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
        </svg>
        <span>New Recording</span>
      </button>
      
      <button 
        *ngIf="isLoggedIn"
        class="logout-button" 
        (click)="onLogout()" 
        title="Log Out">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
        </svg>
        <span>Log Out</span>
      </button>
    </div>
  </div>
</header> 